import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, IconButton, Stack, Typography, alpha } from '@mui/material';
import { ArrowForward, InfoOutlined, VisibilityOffOutlined, WarningAmber } from '@mui/icons-material';
import type { ObligationAlert } from '@/helpers/obligationAlerts';

const ObligationAlertCard = ({ alert, onDismiss, dismissDisabled = false }: {
  alert: ObligationAlert;
  onDismiss: (alert: ObligationAlert) => void;
  dismissDisabled?: boolean;
}) => (
  <Box sx={{ border: 1, borderColor: theme => alpha(theme.palette[alert.severity].main, 0.35), bgcolor: theme => alpha(theme.palette[alert.severity].main, 0.08), borderRadius: 3, p: 2, height: '100%', minWidth: 0 }}>
    <Stack direction="row" spacing={1.25} alignItems="flex-start" sx={{ height: '100%' }}>
      {alert.severity === 'warning' ? <WarningAmber sx={{ color: 'warning.main', mt: 0.25 }} /> : <InfoOutlined sx={{ color: 'info.main', mt: 0.25 }} />}
      <Stack spacing={1} sx={{ flex: 1, minWidth: 0, height: '100%' }}>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
          <Typography variant="subtitle2" fontWeight={700}>{alert.title}</Typography>
          <IconButton size="small" aria-label="Skrýt do zítřka" title="Skrýt do zítřka" disabled={dismissDisabled} onClick={() => onDismiss(alert)}>
            <VisibilityOffOutlined fontSize="small" />
          </IconButton>
        </Stack>
        {alert.buildingName ? <Typography variant="caption" color="text.secondary">Objekt: {alert.buildingName}</Typography> : null}
        <Typography variant="body2" color="text.secondary" sx={{ overflowWrap: 'anywhere' }}>{alert.message}</Typography>
        <Button component={RouterLink} to={alert.actionPath} size="small" endIcon={<ArrowForward />} sx={{ alignSelf: 'flex-start', textTransform: 'none', mt: 'auto' }}>
          {alert.actionLabel}
        </Button>
      </Stack>
    </Stack>
  </Box>
);

export default ObligationAlertCard;
